module.exports = __webpack_public_path__ + "img/ada-post1.cc46dbc5.jpeg";